import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const TeamMemberListItem: FunctionComponent<Props> = ({
    children,
    className = '',
    testId = TEST_ID,
    text
}) => (
    <div className={`${className} ${styles.teamMemberListItem}`} data-testid={testId}>
        {children || text}
    </div>
);

export default TeamMemberListItem;
